import { useEffect, useState } from 'react';

import * as bootstrap from 'bootstrap';
import DOMPurify from 'dompurify';

import { ProductTypeDisplayT } from '@consumer-frontend/nc-utils';

const fixInstallmentLinks = (html: string): string => {
  const htmlDocument = new DOMParser().parseFromString(html, 'text/html');

  const linkIds = [
    '#application_of_payments',
    '#arbitration_provision',
    '#authorization_agreement',
    '#cancellation',
    '#class_action_waiver',
    '#default_and_acceleration',
    '#electronic_fund_transfer',
    '#federal_truth_in_lending_act',
    '#itemization_of_amount_financed',
    '#payment_authorization',
    '#truth_in_lending',
    '#waiver_of_jury_trial',
  ];

  const selector = linkIds.map((linkId) => `a[href="${linkId}"]`).join(', ');
  const links = htmlDocument.querySelectorAll(selector);

  links.forEach((link) => {
    const query = window.location.search;

    link.setAttribute('href', `/contract${query}${link.getAttribute('href')}`);
  });

  return htmlDocument.body.innerHTML;
};

const fixEftModal = () => {
  const eft = '#eft-authorization';
  const eftLink = document.querySelector(`a[data-target="${eft}"]`);

  if (!eftLink) { return; }

  const eftModal = bootstrap.Modal.getOrCreateInstance(eft);
  const eftModalClose = document.querySelector('button[data-dismiss="modal"]');
  const eftModalDismiss = document.querySelector('a[data-dismiss="modal"]');

  eftLink.removeAttribute('data-target');
  eftLink.removeAttribute('data-toggle');
  eftLink.addEventListener('click', (event) => {
    event.preventDefault();
    eftModal.show();
  });

  if (eftModalClose) { eftModalClose.addEventListener('click', () => eftModal.hide()); }
  if (eftModalDismiss) { eftModalDismiss.addEventListener('click', () => eftModal.hide()); }
};

const fixLocLinks = (html: string): string => {
  fixEftModal();
  const htmlDocument = new DOMParser().parseFromString(html, 'text/html');

  const linksIds = [
    '#account-disclosures',
    '#arbitration-provision',
    '#terms-and-conditions',
    '#waiver-provision',
  ];

  const selector = linksIds.map((linkId) => `a[data-target="${linkId}"]`).join(', ');
  const links = htmlDocument.querySelectorAll(selector);

  links.forEach((link) => {
    const href = `${link.getAttribute('data-target')}-section`;
    const query = window.location.search;

    link.setAttribute('href', `/contract${query}${href}`);
    link.removeAttribute('data-target');
    link.removeAttribute('data-toggle');
    link.removeAttribute('data-backdrop');
  });

  return htmlDocument.body.innerHTML;
};

export const useParseContract = (body: string, productTypeDisplay: ProductTypeDisplayT) => {
  const [sanitizedHtml, setSanitizedHtml] = useState(DOMPurify.sanitize(body));

  useEffect(
    () => {
      const fixerFn = productTypeDisplay === 'Line of Credit' ? fixLocLinks : fixInstallmentLinks;
      const parsedHtml = fixerFn(sanitizedHtml);

      setSanitizedHtml(() => parsedHtml);
    },
    [productTypeDisplay, sanitizedHtml],
  );

  return sanitizedHtml;
};
